import { WallMonitor } from './monitor.type';
import { IRectangle } from '../interfaces/irectangle.interface';
import { FunctionType } from '../enums/function-type.enum';
import { WallSharedConstants } from '../../wall-shared.constants';

export class Wall {
  public Id: number;
  public PresetId: number;
  public Monitors: WallMonitor[] = [];

  // Wall settings
  public Rows = 0;
  public Columns = 0;
  public ResolutionWidth: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_W;
  public ResolutionHeight: number = WallSharedConstants.DEFAULT_WALL_RESOLUTION_H;
  public BeselCorrectionWidth = 0;
  public BeselCorrectionHeight = 0;

  public IsAligned: boolean = WallSharedConstants.DEFAULT_WALL_IS_ALIGNED;
  public Zoom: number = WallSharedConstants.DEFAULT_WALL_ZOOM;
  public Width = 0;
  public Height = 0;
  public WallIndex: number;
  public GroupId: number;

  public IsCalibrated = false;
  public IsGridVisible = true;
  public IsSizeLocked = false;
  public LockedArea: IRectangle;
  public IsApplied = false;
  public IsInit?: boolean;
  public WallAngle: number = 0;

  public MonitorGroupType: FunctionType = FunctionType.iDisplay;
  public Title: string;

  constructor(monitors: WallMonitor[] = [], id: number = null, additional: any = {}) {
    Object.assign(this, additional);
    this.Monitors = monitors;
    this.Title = `wall-${this.Id}`;
    this.Columns = this.Columns || 0;
    this.Rows = this.Rows || 0;
    this.Width = this.Width || 0;
    this.Height = this.Height || 0;
    this.GroupId = this.GroupId || 0;
    this.Id = this.Id || id;
  }
}
